document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const vitalsRadios = document.querySelectorAll('.vitals-volume-discount .vitals-radio input[type="radio"]');
    if (vitalsRadios.length) {
      vitalsRadios.forEach((radio) => {
        radio.addEventListener('change', function () {
          const productInfo = document.querySelector('product-info');
          const variantId = radio.getAttribute('data-variant-id');
          if (!productInfo || !variantId) return;

          const selectedOptionValues = [];

          // Buscar los selects de opciones y guardar sus valores
          const selects = productInfo.querySelectorAll('variant-selects select');
          selects.forEach((select) => {
            const optionValue = Array.from(select.options).find(
              (opt) => opt.getAttribute('data-option-value-id') === variantId
            );
            if (optionValue) {
              selectedOptionValues.push(optionValue.value);
              select.value = optionValue.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          // Disparar el evento nativo que tu tema escucha
          const event = new CustomEvent('optionValueSelectionChange', {
            detail: {
              event: null,
              target: radio,
              selectedOptionValues: selectedOptionValues,
            },
          });
          document.dispatchEvent(event);
        });
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
